<template>
  <b-container>
    <unroll-element
      :title="$t('json_preview')"
      :available="json_uid_instantiated"
      :already_in_container="true"
      class="my-4"
    >
      <json-viewer :project_id="project_id" :poid="json_uid" />
    </unroll-element>

    <b-form-group>
      <label>
        <b> {{ $t('table_chosen') }} </b>
      </label>
      <b-form-select v-model="table" :options="table_options" />
    </b-form-group>

    <b-card class="mt-3" :header="$t('input_coercion')">
      <columns-choice-options
        v-model="input_coercion"
        :entry_constructor="generic_column_name_for_coercion_constructor"
      >
        <template #sub_component="props">
          <generic-column-name-edition-for-coercion
            v-bind="props"
            :only_manual="true"
            v-on="props.listeners"
          />
        </template>
      </columns-choice-options>
    </b-card>

    <b-card class="mt-3" :header="$t('operations')">
      <b-card :header="$t('available_operations')">
        <draggable
          v-model="available_operations"
          class="drag-area"
          :group="{ name: 'operations', pull: 'clone', put: 'false' }"
          :clone="clone"
          :sort="false"
        >
          <b-list-group-item
            v-for="operation in available_operations"
            :key="operation.operation_name"
            class="hand-pointer"
          >
            {{ $t(operation.operation_name) }}
          </b-list-group-item>
        </draggable>
      </b-card>

      <b-card class="mt-2" :header="$t('selected_operations')">
        <draggable
          v-model="chained_operations"
          class="drag-area synaplus-cosmo-scroll-higher-720"
          group="operations"
          :revert-on-spill="true"
          :on-spill="delete_item"
        >
          <b-list-group-item
            v-for="operation in chained_operations"
            :key="operation.uid"
            class="hand-pointer"
          >
            {{ $t(operation.operation_name) }}
            <b-form-input
              v-if="
                operation.operation_name == 'select_field' ||
                  operation.operation_name == 'insert_in_field'
              "
              v-model="operation.field_name"
            />
            <!--             <code-editor
              v-if="operation.operation_name == 'execute_code'"
              v-model="operation.code"
            /> -->
            <togglable-code-editor
              v-if="operation.operation_name == 'execute_code'"
              v-model="operation.code"
            />
          </b-list-group-item>
        </draggable>
      </b-card>
    </b-card>
    <b-card class="mt-3" :header="$t('output_coercion')">
      <columns-choice-options
        v-model="output_coercion"
        :entry_constructor="generic_column_name_for_coercion_constructor"
      >
        <template #sub_component="props">
          <generic-column-name-edition-for-coercion
            v-bind="props"
            :only_manual="true"
            v-on="props.listeners"
          />
        </template>
      </columns-choice-options>
    </b-card>
  </b-container>
</template>

<i18n>
{
  "en": {
    "transformation_type": "Transformation type",
    "operations": "Operations",
    "available_operations": "Available operations",
    "selected_operations": "Selected operations",
    "array_from_object": "Transform object to array",
    "select_field": "Select a field",
    "insert_in_field": "Insert in a field",
    "object_to_table": "Transform to array if object",
    "table_to_object": "Transform array to object if it has a unique observation",
    "execute_code": "Execute code",
    "input_coercion": "Table to Json coercion",
    "output_coercion": "Json to Table coercion"
  },
  "fr": {
    "transformation_type": "Type de transformation",
    "operations": "Operations",
    "available_operations": "Opérations disponibles",
    "selected_operations": "Opérations sélectionnées",
    "array_from_object": "Création d'un tableau à partir d'un objet",
    "select_field": "Sélection d'un champ",
    "insert_in_field": "Insertion dans un champ",
    "object_to_table": "Transformation en tableau si objet",
    "table_to_object": "Transformation d'un objet en tableau si observation unique",
    "execute_code": "Exécuter du code",
    "input_coercion": "Coercion de Table vers Json",
    "output_coercion": "Coercion de Json vers Table"

  }
}
</i18n>

<script>
import _ from 'lodash'

import { BListGroupItem } from 'bootstrap-vue'
import draggable from 'vuedraggable'

// import {
//   subscription_mixin,
//   brick_mixin,
//   brick_with_single_parent_mixin,
//   metavariables_tracking_info_mixin,
// } from '@/components/mixin.js'

import { global_brick_mixin } from '@/components/mixin.js'

import ColumnsChoiceOptions from './columns_choice_options.vue'
import GenericColumnNameEditionForCoercion from './generic_column_name_edition_for_coercion.vue'
import {
  BasicTableInfoEntity,
  GenericColumnNameForCoercion,
} from '@/components/object_model.js'

import TogglableCodeEditor from '@/components/togglable_code_editor.vue'
import UnrollElement from '@/components/unroll_element.vue'
import JsonViewer from '@/components/json_viewer.vue'

// *****************************************************************************

export default {
  name: 'BrickApiTable',
  components: {
    draggable,
    ColumnsChoiceOptions,
    GenericColumnNameEditionForCoercion,
    TogglableCodeEditor,
    UnrollElement,
    JsonViewer,
  },
  // mixins: [subscription_mixin, brick_mixin, brick_with_single_parent_mixin],
  mixins: [global_brick_mixin],

  // props: [
  //   'brick_id',
  //   'project_id',
  //   'description_name',
  //   'metavariables_dicts_poids',
  // ],
  data() {
    return {
      table: -1,
      input_coercion: [],
      output_coercion: [],
      chained_operations: [],

      available_operations: [
        { operation_name: 'select_field', field_name: '' },
        { operation_name: 'insert_in_field', field_name: '' },
        { operation_name: 'object_to_table' },
        { operation_name: 'table_to_object' },
        { operation_name: 'execute_code', code: '' },
      ],
    }
  },
  computed: {
    json_uid() {
      let res = (this.tracking_info || {}).json_uid
      return res
    },
    json_uid_instantiated() {
      return this.fetch_poid_status('pid_status', this.json_uid)
    },
    generic_column_name_for_coercion_constructor() {
      return GenericColumnNameForCoercion
    },
    adapted_data() {
      let extended_table_info = []
      if (this.table !== -1) {
        let parent_info_entity_type = new BasicTableInfoEntity()
        parent_info_entity_type.uid = this.table
        extended_table_info.push(parent_info_entity_type)
      }

      let adapted = {
        uid: this.brick_id,
        parents_info: extended_table_info,
        input_coercion: _.cloneDeep(this.input_coercion),
        output_coercion: _.cloneDeep(this.output_coercion),
        chained_operations: _.cloneDeep(this.chained_operations),
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(new_val) {
        this.table = (((new_val || {}).parents_info || [])[0] || {}).uid || -1
        this.input_coercion = _.cloneDeep(new_val.input_coercion)
        this.output_coercion = _.cloneDeep(new_val.output_coercion)
        this.chained_operations = _.cloneDeep(new_val.chained_operations)
      },
    },
    table: {
      immediate: true,
      async handler(new_val) {
        let parent_brick = this.bricks_undeleted['bricks'][new_val]
      },
    },
  },

  methods: {
    delete_item(evt) {
      this.chained_operations.splice(evt.newIndex, 1)
    },
    clone(element) {
      let res = _.cloneDeep(element)
      res.uid = _.uniqueId()
      return res
    },
  },
}
</script>
